import React from 'react';
import { Checkbox as ChakraCheckbox, CheckboxProps as ChakraCheckboxProps } from '@chakra-ui/react';

export function Checkbox(props: ChakraCheckboxProps) {
  return <ChakraCheckbox {...props} />;
}
